import React, { Component } from 'react';
import PaymentInfo from './PaymentInfo'
import withPricing from './components/withPricing';

class PaymentServiceContainer extends Component {
    
    render() {
        return (
            <div>
				<PaymentInfo 
					{...this.props}
                />
            </div>
        );
    }
}

// wrap the component in the workflow HOC to get access to common workflow logic
export default withPricing(PaymentServiceContainer);
